import { create } from "zustand";
import { persist } from "zustand/middleware";

import type { User } from "@/api/schemas";
import { useSessionStore } from "./session.store";

export type AuthUserProfile = Pick<User, "username"> & Partial<Omit<User, "username">>;

interface AuthState {
  user: AuthUserProfile;
  accessToken: string;
  isAuthenticated: boolean;
  setAuth: (payload: { accessToken: string; user?: AuthUserProfile }) => void;
  setUser: (user: AuthUserProfile) => void;
  logout: () => void;
}

export const useAuthStore = create<AuthState>()(
  persist(
    (set) => ({
      user: { username: "" },
      accessToken: "",
      isAuthenticated: false,
      
      setAuth: ({ accessToken, user }) =>
        set({
          accessToken,
          isAuthenticated: true,
          ...(user !== undefined ? { user } : {}),
        }),

      setUser: (user) => set({ user }),

      logout: () => {
        useSessionStore.getState().clearActiveStore();
        set({
          user: { username: "" },
          accessToken: "",
          isAuthenticated: false,
        });
      },
    }),
    {
      name: "auth-storage",
      partialize: (state) => ({
        user: state.user,
        accessToken: state.accessToken,
        isAuthenticated: state.isAuthenticated,
      }),
    },
  ),
);
